var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBypassIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7181_9714)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_7181_9714)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.83301 1.83203C5.83301 1.36603 5.83301 1.13303 5.90901 0.949031C6.0105 0.704114 6.20509 0.509522 6.45001 0.408031C6.63401 0.332031 6.86701 0.332031 7.33301 0.332031C7.79901 0.332031 8.03301 0.332031 8.21601 0.408031C8.46101 0.509031 8.65601 0.704031 8.75701 0.949031C8.83301 1.13303 8.83301 1.36603 8.83301 1.83203V5.33203H5.83301V1.83203ZM5.83301 14.832V11.332H8.83301V14.832C8.83301 15.298 8.83301 15.531 8.75701 15.715C8.65552 15.9599 8.46092 16.1545 8.21601 16.256C8.03201 16.332 7.79901 16.332 7.33301 16.332C6.86701 16.332 6.63301 16.332 6.45001 16.256C6.20509 16.1545 6.0105 15.9599 5.90901 15.715C5.83301 15.531 5.83301 15.298 5.83301 14.832Z",
    fill: "#FFFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9332 3.48233C12.027 3.3886 12.1541 3.33594 12.2867 3.33594C12.4193 3.33594 12.5464 3.3886 12.6402 3.48233L16.6402 7.48233C16.7339 7.57609 16.7866 7.70325 16.7866 7.83583C16.7866 7.96841 16.7339 8.09557 16.6402 8.18933L12.6402 12.1893C12.5459 12.2804 12.4196 12.3308 12.2885 12.3297C12.1574 12.3285 12.032 12.2759 11.9393 12.1832C11.8466 12.0905 11.794 11.9651 11.7929 11.834C11.7917 11.7029 11.8421 11.5766 11.9332 11.4823L15.0832 8.33233H1.2832C1.15059 8.33233 1.02342 8.27965 0.92965 8.18588C0.835882 8.09212 0.783203 7.96494 0.783203 7.83233C0.783203 7.69972 0.835882 7.57255 0.92965 7.47878C1.02342 7.38501 1.15059 7.33233 1.2832 7.33233H15.0832L11.9332 4.18233C11.8395 4.08857 11.7868 3.96141 11.7868 3.82883C11.7868 3.69625 11.8395 3.56909 11.9332 3.47533V3.48233Z",
    fill: "#FFFBFB"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7181_9714"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_7181_9714"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.833008 0.332031)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBypassIcon);
export default __webpack_public_path__ + "static/media/bypass_icon.e1716991736c9b990f5b4fcb69e155b0.svg";
export { ForwardRef as ReactComponent };